/**
 * Quiz countdown bar (PlayerScene › Clock, Timer.cs): a grey pill at the bottom
 * with a clock icon, a red→green gradient bar that a grey mask covers from the
 * right as time runs out, and the remaining seconds riding at the end of the
 * coloured part. Geometry is the scene's (1900×111 at 24 px from the bottom,
 * bar 1788 wide).
 */
import { useEffect, useState } from "react";
import { libraryUrl } from "../data/media";

const BAR = 1788;

export function Clock({ seconds, startedAt, onTimeUp }: { seconds: number; startedAt: number; onTimeUp: () => void }) {
  const [remaining, setRemaining] = useState(seconds);
  useEffect(() => {
    let raf = 0;
    let fired = false;
    const tick = () => {
      const r = Math.max(0, seconds - (Date.now() - startedAt) / 1000);
      setRemaining(r);
      if (r <= 0) {
        if (!fired) {
          fired = true;
          onTimeUp();
        }
        return;
      }
      raf = window.requestAnimationFrame(tick);
    };
    raf = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(raf);
  }, [seconds, startedAt, onTimeUp]);

  const frac = Math.min(1, remaining / seconds);
  const colored = Math.max(80, BAR * frac);
  return (
    <div className="clock" style={{ backgroundImage: `url(${libraryUrl("ui/clockBg.png")})` }} aria-live="off">
      <img className="clock-icon" src={libraryUrl("ui/clockIcon.png")} alt="" draggable={false} />
      <div className="clock-bar" style={{ backgroundImage: `url(${libraryUrl("ui/clockBar.png")})` }} />
      <div className="clock-mask" style={{ width: BAR - colored }} />
      <div className="clock-time" style={{ width: colored }}>
        {Math.floor(remaining)}
      </div>
    </div>
  );
}

/** Timer.cs: slides without a limit get 20 s. */
export function clockSeconds(slideSeconds: number): number {
  return slideSeconds > 0 ? slideSeconds : 20;
}
